export default sourceStreamId =>
  (sourceStreamId === 'P2P' ? 'RELAYED' : 'ROUTED');
